<template>
  <div class="home">
    <auth />
  </div>
</template>

<script>
// @ is an alias to /src
import Authentication from '@/components/Authentication.vue';

export default {
  name: 'Home',
  components: {
    auth: Authentication,
  },
};
</script>